module.exports = __webpack_public_path__ + "img/home1.30b87735.png";